export default __webpack_public_path__ + "static/media/featSportMb.3ae4900a.png";